import { fail } from "@sveltejs/kit";
import { s as sendEmail } from "../../../../chunks/mailService.js";
import { p as prisma } from "../../../../chunks/prisma.js";
import auth from "../../../../chunks/auth.js";
const load = (async () => {
  return {};
});
const actions = {
  default: async ({ request, url }) => {
    const formData = await request.formData();
    const email = formData.get("email")?.toString();
    if (!email) return fail(400, { message: "Email is required", data: { email } });
    try {
      const user = await prisma.user.findUnique({
        where: { email }
      });
      if (!user) return fail(400, { message: "You do not have an account with us", data: { email } });
      const resetToken = auth.generateResetToken(user.id);
      const link = url.origin + `/reset-password?token=${resetToken}`;
      const origin = url.origin;
      const emailSent = await sendEmail(user.email, "Password Reset", "password-reset", { link, origin });
      console.log("Email Sent: please check your mailbox ", emailSent);
    } catch (e) {
      console.error("Error with sending email:", e);
      return fail(500, { message: "Something went wrong", data: { email } });
    }
  }
};
export {
  actions,
  load
};
